/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2021] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import _ from 'lodash';
import NProgress from 'nprogress';
import Backbone from 'backbone';

import Scaffold from '@/Scaffold';
import * as NavUtils from '@/util/NavUtils';
import { getUserDetails, isAuthorized } from '@/util/RoleUtils';
import ErrorView from '@/views/ErrorView';

import GetExternalUserCommands from '../services/GetExternalUserCommands';
import ExtDashboardPage from '../pages/ExtDashboardPage';
import UpdateUserActingAsCommand from '../services/UpdateUserActingAsCommand';

export default async function ShowExtDashboardPage(newcommandID) {
  // Messenger().hideAll();
  NProgress.start();

  try {
    if (!isAuthorized() && EXTERNAL) {
      showAuthError();
      return;
    } else if (!EXTERNAL) {
      showErrorView();
    }

    let commandID = parseInt(newcommandID);

    if (commandID) {
      NavUtils.navigate(`ext/dashboard/command/${commandID}`);
    } else {
      NavUtils.navigate('ext/dashboard');
      const userDetails = getUserDetails();
      commandID = userDetails.actingAsCommandId;
    }

    const [commands, command] = await Promise.all([GetExternalUserCommands(), UpdateUserActingAsCommand(commandID)]);
    if (commands) {
      if (command) {
        Scaffold.getRegion('content').show(
          new ExtDashboardPage({
            model: new Backbone.Model({
              commands,
              command
            })
          })
        );
      } else {
        throw 'Invalid Command';
      }
    } else {
      throw 'User has no commands.';
    }
  } catch (err) {
    Scaffold.getRegion('content').show(
      new ErrorView({
        model: new Backbone.Model({
          errorMessage: _.isString(err.message) ? err.message : 'An Error Occurred',
          errorDetails: 'Something went wrong while loading the Customer Dashboard page.'
        })
      })
    );
  } finally {
    NProgress.done();
  }
}

function showAuthError() {
  Scaffold.getRegion('content').show(
    new ErrorView({
      model: new Backbone.Model({
        errorMessage: 'Not Authorized',
        errorDetails: 'You are not yet an authorized user. Please contact an administrator.'
      })
    })
  );
  NProgress.done();
}

function showErrorView() {
  Scaffold.getRegion('content').show(
    new ErrorView({
      model: new Backbone.Model({
        errorMessage: 'Access Denied',
        errorDetails: 'Your account may not have permission to view the Customer Home Dashboard page.'
      })
    })
  );
  NProgress.done();
}